<template>
    <v-container class="my-5">
      <!--  Diálogo para mostrar Detalles del Comunicado   -->
      <v-dialog
          v-model="dialogView"
          scrollable
          max-width="700"
          :fullscreen="$vuetify.breakpoint.xsOnly"
      >
        <v-card
            class="elevation-8"
            :class="{ 'rounded-xl': !$vuetify.breakpoint.xsOnly }"
            style="overflow: hidden;"
        >
          <v-img
              v-if="itemDetail.file && extensionImage(itemDetail.file) === true"
              :src="itemDetail.file"
              height="260"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,0) 35%, rgba(0,0,0,.75)"
          >
            <v-btn
                class="notice-dialog-close"
                color="white"
                icon
                @click="dialogView = false"
            ><v-icon>mdi-close</v-icon></v-btn>
            <v-card-title class="notice-dialog-title">{{itemDetail.title}}</v-card-title>
          </v-img>
          <div v-else class="notice-dialog-header d-flex align-center">
            <v-btn
                class="notice-dialog-close"
                color="white"
                icon
                @click="dialogView = false"
            ><v-icon>mdi-close</v-icon></v-btn>
            <v-icon size="44" color="white" class="ml-5 mr-4">mdi-bullhorn</v-icon>
            <div class="notice-dialog-title pr-12">{{itemDetail.title}}</div>
          </div>
          <v-card-text class="pt-5">
            <v-sheet color="grey lighten-4" rounded="lg" class="pa-4">
              <p v-if="itemDetail.comments" class="body-1 mb-0" style="white-space: pre-line;">{{itemDetail.comments}}</p>
              <p v-else class="body-1 mb-0 grey--text font-italic">Sin comentarios adicionales.</p>
            </v-sheet>
          </v-card-text>
          <v-card-actions class="justify-center pb-5" v-if="itemDetail.file">
            <v-btn
                @click="newPage(itemDetail.file)"
                color="primary"
                rounded
                large
            >
              <v-icon left>{{extensionImage(itemDetail.file) === true ? 'mdi-file-image' : 'mdi-file-pdf-box'}}</v-icon>
              {{$t('descargar')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Comunicado     -->
        <v-dialog v-model="deleteDialog" max-width="380">
            <v-card class="rounded-xl text-center elevation-8 pa-2">
                <v-card-text class="pt-7 pb-2">
                    <v-avatar color="error lighten-5" size="72" class="mb-4">
                        <v-icon color="error" size="38">mdi-delete-alert-outline</v-icon>
                    </v-avatar>
                    <p class="headline mb-1">{{$t('msg_delete_notice')}}</p>
                    <p v-if="noticeToDelete" class="body-1 font-weight-medium primary--text mb-1 text-truncate">
                        "{{noticeToDelete.title}}"
                    </p>
                    <p class="caption grey--text text--darken-1 mb-0">{{$t('msg_accion_deshacer')}}</p>
                </v-card-text>

                <v-card-actions class="pa-4">
                    <v-btn
                            text
                            rounded
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="error"
                            dark
                            rounded
                            @click="deleteNotice()"
                    >
                        <v-icon left small>mdi-delete</v-icon>
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Agregar / Editar Comunicado     -->
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="500"
            :fullscreen="$vuetify.breakpoint.xsOnly"
        >
            <v-form
                    @submit.prevent="update
                        ? updateNotice(idUpdate)
                        : addNotice()"
            >
                <v-card
                    class="elevation-8"
                    :class="{ 'rounded-xl': !$vuetify.breakpoint.xsOnly }"
                    style="overflow: hidden;"
                >
                    <div class="notice-dialog-header d-flex align-center">
                        <v-btn
                                class="notice-dialog-close"
                                color="white"
                                icon
                                @click="clear(), dialog = false"
                        ><v-icon>mdi-close</v-icon></v-btn>
                        <v-icon size="40" color="white" class="ml-5 mr-4">{{update ? 'mdi-pencil' : 'mdi-bullhorn-outline'}}</v-icon>
                        <div class="notice-dialog-title pr-12">
                            {{ update ? $t('modificar') + ' ' + $t('notice') : $t('add_notice') }}
                        </div>
                    </div>
                    <v-card-text class="pt-6">
                        <v-text-field
                                v-if="dialog" autofocus
                                v-model="title"
                                name="title"
                                outlined
                                dense
                                counter
                                maxlength="100"
                                prepend-inner-icon="mdi-format-title"
                                :label="'*' + $t('title')"
                                :error-messages="errores.title"
                        ></v-text-field>
                        <v-textarea
                                v-model="comments"
                                name="comments"
                                outlined
                                dense
                                counter
                                maxlength="300"
                                rows="3"
                                prepend-inner-icon="mdi-comment-edit-outline"
                                :label="$t('comments')"
                                :error-messages="errores.comments"
                        ></v-textarea>
                        <v-checkbox
                                v-model="change"
                                name="change"
                                class="mt-0"
                                :label="update === false ? $t('agregar') + ' '+ $t('file') : $t('modificar') + ' '+ $t('file')"
                        ></v-checkbox>
                        <v-alert
                            v-if="update && !change && file"
                            dense
                            text
                            type="info"
                            icon="mdi-paperclip"
                            class="mb-3"
                        >
                          Este comunicado ya tiene un archivo adjunto. Marca la casilla para reemplazarlo.
                        </v-alert>
                        <v-expand-transition>
                          <div v-if="change">
                            <v-file-input
                                v-model="file"
                                :rules="rules"
                                outlined
                                dense
                                accept="image/png, image/jpeg, .pdf"
                                placeholder="image/pdf"
                                prepend-icon=""
                                prepend-inner-icon="mdi-paperclip"
                                @change="oversized_function"
                                :error-messages="errores.file"
                                :label="update && file !== null ? $t('file'): $t('modificar')"
                            ></v-file-input>
                            <v-img
                                v-if="filePreviewUrl"
                                :src="filePreviewUrl"
                                max-height="170"
                                contain
                                class="rounded-lg grey lighten-3 mb-3"
                            ></v-img>
                            <div
                                v-else-if="file && file.size > 100 && !extensionImage(file.name)"
                                class="d-flex align-center grey lighten-4 rounded-lg pa-3 mb-3"
                            >
                              <v-icon color="red" large class="mr-3">mdi-file-pdf-box</v-icon>
                              <span class="text-truncate">{{file.name}}</span>
                            </div>
                          </div>
                        </v-expand-transition>
                    </v-card-text>
                    <v-card-actions class="pa-4">
                        <v-btn text rounded @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                        <v-spacer/>
                        <v-btn v-if="update" :disabled="oversized" :loading="loading" color="primary" type="submit" rounded>{{$t('modificar')}}</v-btn>
                        <v-btn v-else :loading="loading" :disabled="oversized" color="primary" type="submit" rounded>{{$t('agregar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-card class="elevation-3 rounded-lg">
          <v-toolbar dark color="primary" flat>
            <v-toolbar-title>
              <v-icon left dark>mdi-bullhorn-outline</v-icon>
              {{$t('Notices')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                v-if="getProfile.role === 1"
                color="white"
                outlined
                class="mr-2"
                @click="change = false, update = false, cleanFields(), dialog = true"
            >
              <v-icon left>mdi-plus</v-icon>
              {{$t('add_notice')}}
            </v-btn>
            <v-btn icon dark :loading="loadingDataNotices" @click="getNotices">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-5">
            <v-text-field
                v-if="!loadingDataNotices && notices.length > 0"
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar comunicado..."
                outlined
                dense
                hide-details
                clearable
                class="mb-5"
            ></v-text-field>

            <!-- Estado de Carga -->
            <v-row v-if="loadingDataNotices" dense>
              <v-col
                  v-for="n in 4"
                  :key="'skeleton-' + n"
                  cols="12" sm="6" md="4" lg="3"
              >
                <v-skeleton-loader type="image, article"></v-skeleton-loader>
              </v-col>
            </v-row>

            <!-- Estado Vacío -->
            <v-row v-else-if="filteredNotices.length === 0" justify="center">
              <v-col cols="12" class="text-center py-12">
                <v-icon size="90" color="grey lighten-1">mdi-bullhorn-variant-outline</v-icon>
                <p class="title grey--text text--darken-1 mt-4 mb-1">{{$t('no_records_yet')}}</p>
                <p class="body-2 grey--text" v-if="getProfile.role === 1">
                  Comparte el primer comunicado con tus residentes.
                </p>
              </v-col>
            </v-row>

            <!-- Tarjetas de Comunicados -->
            <v-row v-else dense>
              <v-col
                  v-for="notice in filteredNotices"
                  :key="notice.id"
                  cols="12" sm="6" md="4" lg="3"
              >
                <v-card class="notice-card rounded-lg elevation-2">
                  <v-img
                      v-if="notice.file && extensionImage(notice.file) === true"
                      :src="notice.file"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,0) 45%, rgba(0,0,0,.75)"
                      height="190px"
                  >
                    <v-card-title class="notice-title" v-text="notice.title"></v-card-title>
                  </v-img>
                  <v-img
                      v-else
                      class="white--text align-end"
                      :src=" require('../../assets/megaphone.png')"
                      gradient="to top right, rgba(19,84,122,.6), rgba(67,160,71,.85)"
                      height="190px"
                  >
                    <v-card-title class="notice-title" v-text="notice.title"></v-card-title>
                  </v-img>
                  <v-card-text class="notice-comments pt-3 pb-1">
                    {{notice.comments}}
                  </v-card-text>
                  <v-card-actions>
                    <v-chip v-if="notice.file" x-small outlined color="primary">
                      <v-icon x-small left>{{extensionImage(notice.file) === true ? 'mdi-image' : 'mdi-file-pdf-box'}}</v-icon>
                      {{extensionImage(notice.file) === true ? 'Imagen' : 'PDF'}}
                    </v-chip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-if="getProfile.role === 1"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            small
                            color="blue darken-1"
                            @click="fillFields(notice), update = true, dialog = true, change = false, idUpdate = notice.id"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>{{$t('change')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-if="getProfile.role === 1"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            small
                            color="red darken-1"
                            @click="deleteDialog = true, noticeToDelete = notice"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{$t('delete')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            small
                            @click="itemDetail = notice, dialogView = true"
                        >
                          <v-icon small>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{$t('details')}}</span>
                    </v-tooltip>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'notices',
  created () {
    this.getNotices()
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    filteredNotices () {
      if (!this.search) {
        return this.notices
      }
      const query = this.search.toLowerCase()
      return this.notices.filter(notice =>
        (notice.title && notice.title.toLowerCase().includes(query)) ||
        (notice.comments && notice.comments.toLowerCase().includes(query))
      )
    }
  },
  data: () => ({
    dialog: false,
    title: '',
    comments: '',
    titleAux: '',
    commentsAux: '',
    loadingDataNotices: false,
    loading: false,
    notices: [],
    search: '',
    errores: [],
    idUpdate: 0,
    noticeToDelete: null,
    deleteDialog: false,
    file: null,
    filePreviewUrl: null,
    update: false,
    change: false,
    rules: [],
    oversized: false,
    dialogView: false,
    itemDetail: {
      id: '',
      title: '',
      file: '',
      comments: ''
    }
  }),
  beforeUpdate () {
    this.rules = [
      value => !value || value.size < 2000000 || this.$t('msg_overflow_file')
    ]
  },
  watch: {
    file () {
      this.refreshFilePreview()
    },
    change () {
      this.refreshFilePreview()
    }
  },
  methods: {
    refreshFilePreview () {
      if (this.filePreviewUrl) {
        URL.revokeObjectURL(this.filePreviewUrl)
        this.filePreviewUrl = null
      }
      if (this.change && this.file instanceof File && this.file.size > 100 && this.extensionImage(this.file.name)) {
        this.filePreviewUrl = URL.createObjectURL(this.file)
      }
    },
    newPage (url) {
      window.open(url, '_blank')
    },
    oversized_function (value) {
      console.log('Valor Archivo = ', value)
      if (value !== null) {
        if (value.size > 2048 * 1024) {
          this.oversized = true
        } else {
          this.oversized = false
        }
        console.log('ERoores = ', this.errores.file)
        if (this.change === true && this.errores.file) {
          this.errores.file = ''
        }
      } else {
        this.oversized = false
      }
    },
    getNotices () {
      this.loadingDataNotices = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/notice_create_get/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.notices = response.data
          this.loadingDataNotices = false
        })
        .catch(error => {
          this.loadingDataNotices = false
          console.log(error)
        })
    },
    addNotice () {
      console.log('File = ', this.file)
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      bodyFormData.set('idHousingUnit', this.getProfile.idHousingUnit)
      bodyFormData.set('title', this.title)
      if (this.comments !== '') {
        bodyFormData.set('comments', this.comments)
      }
      if (this.change === true) {
        bodyFormData.append('file', this.file)
      }
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/notice_create_get/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_added_notice'))
          this.dialog = false
          this.getNotices()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    updateNotice (id) {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      if (this.title !== this.titleAux) {
        bodyFormData.set('title', this.title)
      }
      if (this.comments !== this.commentsAux) {
        bodyFormData.set('comments', this.comments)
      }
      if (this.change === true) {
        bodyFormData.append('file', this.file)
      }
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/notice_get_detail_and_update_it/' + id + '/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getNotices()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_notice_updated'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    deleteNotice () {
      const config = {
        method: 'delete',
        url: ' https://residencial-services.intrare.app/notice_get_detail_and_update_it/' + this.noticeToDelete.id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Notice con ID = ', this.noticeToDelete.id + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_notice_deleted'))
        this.getNotices()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    cleanFields () {
      this.title = ''
      this.comments = ''
      this.file = null
      this.oversized = false
    },
    fillFields (item) {
      if (item.file !== null) {
        var fileAux = new File(['foo'], item.file)
        this.file = fileAux
      }
      this.title = item.title
      this.comments = item.comments
      this.titleAux = item.title
      this.commentsAux = item.comments
      this.oversized = false
    },
    clear: function () {
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    extensionImage (url) {
      if (url.includes('.png') || url.includes('.gif') || url.includes('.jpeg') || url.includes('.jpg')) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.notice-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform .2s ease, box-shadow .2s ease;
}
.notice-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, .18) !important;
}
.notice-title {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25;
  word-break: break-word;
}
.notice-comments {
  flex: 1 1 auto;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: rgba(0, 0, 0, .6);
  font-size: .875rem;
}
.notice-dialog-close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}
.notice-dialog-header {
  position: relative;
  min-height: 96px;
  padding: 16px 0;
  background: linear-gradient(135deg, rgba(19, 84, 122, .92), rgba(67, 160, 71, .92));
}
.notice-dialog-title {
  color: #fff;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.3;
  word-break: break-word;
}
</style>
